module.exports = __webpack_public_path__ + "img/lepricon.91944e4c.png";